// extracted by mini-css-extract-plugin
export default {"taskname":"style_taskname__hDLT0","textarea":"style_textarea__O996x","aaa":"style_aaa__5avRR","overlay":"style_overlay__IoYY9","load":"style_load__pGX-t"};